/**
 * Склонение «устройство» по числу.
 * 1 — устройство; 2–4 — устройства; 5–20 / 11–14 — устройств.
 */
export function pluralizeDevices(count: number, withCapitalLetter = false): string {
  const mod10 = count % 10;
  const mod100 = count % 100;

  let result: string;
  if (mod100 >= 11 && mod100 <= 14) {
    result = 'устройств';
  } else if (mod10 === 1) {
    result = 'устройство';
  } else if (mod10 >= 2 && mod10 <= 4) {
    result = 'устройства';
  } else {
    result = 'устройств';
  }

  if (withCapitalLetter) {
    return result.charAt(0).toUpperCase() + result.slice(1);
  }
  return result;
}
